var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveDashboardVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.12109 1.12109 0 2.5 0H12.5C13.8789 0 15 1.12109 15 2.5V12.5C15 13.8789 13.8789 15 12.5 15H2.5C1.12109 15 0 13.8789 0 12.5V2.5ZM21.8398 1.39844C22.2461 1.61719 22.5 2.03906 22.5 2.5V12.5C22.5 12.9609 22.2461 13.3828 21.8398 13.6016C21.4336 13.8203 20.9414 13.7969 20.5547 13.5391L16.8047 11.0391L16.25 10.668V10V5V4.33203L16.8047 3.96094L20.5547 1.46094C20.9375 1.20703 21.4297 1.17969 21.8398 1.39844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveDashboardVideo);
export default __webpack_public_path__ + "static/media/ic_active_dashboard_video.0ab9faa4a4394185ddc73916c5c83a75.svg";
export { ForwardRef as ReactComponent };